import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.assets',
		defaultMessage: 'Assets',
		description: 'The link label for Assets',
	},
});
